document.addEventListener('DOMContentLoaded', function () {
  if (!window.NkSmartSearch) return;

  var urlParams = new URLSearchParams(window.location.search);
  var query = urlParams.get('q') || '';
  if (!query.trim()) return;

  var banner = document.getElementById('nk-search-banner');

  var BANNER_IDS = {
    root: 'nk-search-banner',
    interpreted: 'nk-banner-interpreted',
    interpretedText: 'nk-banner-interpreted-text',
    language: 'nk-banner-language',
    languageText: 'nk-banner-language-text',
    didYouMean: 'nk-banner-did-you-mean',
    didYouMeanText: 'nk-banner-did-you-mean-text',
    corrections: 'nk-banner-corrections',
    correctionsText: 'nk-banner-corrections-text',
    refineSection: 'nk-refine-section',
    refineList: 'nk-refine-chip-list',
    relatedSection: 'nk-related-section',
    relatedList: 'nk-related-chip-list'
  };

  // Normal flow (floating bar): discovery_attribute is already in the URL.
  // Primary filter is applied by the block from the URL. We still dispatch
  // nk:ai-filters-ready so any extra filters the AI found (e.g. age_group
  // when instant-match only set occasion) get stacked on top.
  if (urlParams.has('discovery_attribute')) {
    try {
      var raw = sessionStorage.getItem('nk_ai_result');
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && cached.q === query.toLowerCase() && (Date.now() - cached.ts) < 30000) {
          sessionStorage.removeItem('nk_ai_result');
          if (banner) NkSmartSearch.renderInterpretationPanel(cached.data, query, BANNER_IDS);
          window.dispatchEvent(new CustomEvent('nk:ai-filters-ready', { detail: cached.data }));
          return;
        }
      }
    } catch (e) {}

    NkSmartSearch.smartSearch(query)
      .then(function (data) {
        if (banner) NkSmartSearch.renderInterpretationPanel(data, query, BANNER_IDS);
        window.dispatchEvent(new CustomEvent('nk:ai-filters-ready', { detail: data }));
      })
      .catch(function () {});
    return;
  }

  // Fallback: direct navigation to /search?q=... with no discovery_attribute.
  // The block shows a loading overlay. We call AI, apply filters in-place, reveal grid.
  NkSmartSearch.smartSearch(query)
    .then(function (data) {
      if (banner) NkSmartSearch.renderInterpretationPanel(data, query, BANNER_IDS);
      window.dispatchEvent(new CustomEvent('nk:ai-filters-ready', { detail: data }));
    })
    .catch(function (err) {
      console.error('Search interpretation failed:', err);
      window.dispatchEvent(new CustomEvent('nk:ai-filters-ready', { detail: null }));
    });
});
